import $ from "jquery";
import setNav from "./setnav";
import mobileMenu from "./mobilemenu";
import desktopMenu from "./desktopmenu";
import mailchimp from "./mailchimp";
import lazysizes from "lazysizes";

/***** Get it goin' *****/
document.addEventListener(
  "DOMContentLoaded",
  () => {
    setNav();
    mobileMenu();
    desktopMenu();
    mailchimp();
  },
  false
);



// WEBPACK FOOTER //
// ./src/scripts/functions/init.js